<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('manual')">
            <a :href="urlGenerator('/hotel/manual-category')" v-if="$can('view_hotel_manual_category')"
               class="btn btn-success btn-with-shadow mr-1">
                <app-icon name="list" class="size-20 mr-2"/>
                {{ $t('category') }}
            </a>
            <app-default-button
                :title="$fieldTitle('add', 'category', true)"
                v-if="$can('create_hotel_manual_category')"
                @click="openModalType()"
            />
            <app-default-button
                :title="$fieldTitle('add', 'manual', true)"
                v-if="$can('create_hotel_manual')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="hotel-manual-table"
            :options="options"
            :card-view="true"
            @action="triggerActions"
            @getFilteredValues="getFilterValues"
        />

        <app-hotel-manual-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-hotel-manual-category-modal
            v-if="isModalCategoryActive"
            v-model="isModalCategoryActive"
            :selected-url="selectedUrl"
            @close="isModalCategoryActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('hotel-manual-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import HotelManualMixins from "../../../Mixins/HotelManualMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AppHotelManual",
    mixins: [HelperMixin, HotelManualMixins, TENANT_BASE_URL],
    data() {
        return {
            isModalCategoryActive: false,
            isModalActive        : false,
            selectedUrl          : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/hotel/manual/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
        openModalType() {
            this.isModalCategoryActive = true;
            this.selectedUrl           = ''
        },
    }
}
</script>